import React, { FC } from 'react'
import ViewClientContainer from 'containers/ViewClient'

const ViewClientPage: FC = () => <ViewClientContainer />

export default ViewClientPage
